import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
} from "@mui/material";
import ToggleOnIcon from "@mui/icons-material/ToggleOn";
import ToggleOffIcon from "@mui/icons-material/ToggleOff";

const thBackgoundColor = "#3a8ddd";
const thFontColor = "white";
const thFontWeight = "bold";
const paperStyles = { width: "100%", height: "calc(100vh - 600px)" };
const tableHeight = { height: "calc(100vh - 650px)" };

const columns = [
  {
    label: "Column Name",
    keyField: "columnKey",
    dataField: "name",
    fieldType: "string",
  },
  {
    label: "Number",
    keyField: "columnKey",
    dataField: "columnNumber",
    fieldType: "number",
  },
  {
    label: "PHI",
    keyField: "columnKey",
    dataField: "phi",
    fieldType: "boolean",
    minWidth: 20,
    maxWidth: 20,
  },
  {
    label: "Status",
    keyField: "columnKey",
    dataField: "active",
    fieldType: "boolean",
    minWidth: 20,
    maxWidth: 20,
  },
];

export const FileTypeColumnUpdate = (props) => {
  const { data, updateFileTypeColumnsValue } = props;

  const [localData, setLocalData] = useState(data);
  const [searchQuery, setSearchQuery] = useState("");

  const handleSearch = (event) => {
    setSearchQuery(event.target.value);
  };

  const filteredData = localData.filter((row) =>
    columns.some(
      (col) =>
        col.fieldType === "string" &&
        row[col.dataField]?.toLowerCase().includes(searchQuery?.toLowerCase())
    )
  );

  const changeStatus = (key, dataField) => {
    const updatedData = localData?.map((row) => {
      if (row.columnKey === key) {
        return { ...row, [dataField]: !row[dataField] };
      }
      return row;
    });

    setLocalData(updatedData);

    updateFileTypeColumnsValue(
      key,
      dataField,
      !localData.find((row) => row.columnKey === key)[dataField]
    );
  };

  return (
    <Paper sx={paperStyles}>
      <TextField
        size="small"
        sx={{ float: "right", marginBottom: "8px" }}
        placeholder="Search"
        value={searchQuery}
        onChange={handleSearch}
      />
      <TableContainer sx={tableHeight}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns?.map((column, index) => (
                <TableCell
                  key={column.label + "_" + index}
                  align={column["align"]}
                  style={{
                    backgroundColor: thBackgoundColor,
                    color: thFontColor,
                    fontWeight: thFontWeight,
                    padding: "8px 0px 8px 8px",
                    minWidth: column["minWidth"] ? column["minWidth"] : 150,
                  }}
                >
                  {column.label !== "" && <>{column.label}</>}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredData?.map((row, idx) => {
              return (
                <TableRow
                  sx={{ padding: "0px" }}
                  hover
                  role="checkbox"
                  tabIndex={-1}
                  key={"row_" + idx}
                >
                  {columns.map((col, colIdx) => {
                    const value = row[col["dataField"]];
                    return (
                      <TableCell
                        sx={{ padding: "0px 0px 0px 8px" }}
                        key={"cols_" + colIdx + "_" + row[col["keyField"]]}
                        align={col["align"]}
                      >
                        {col["dataType"] !== "date" && <>{value}</>}
                        {typeof value === "boolean" && (
                          <div
                            style={{
                              cursor: "pointer",
                              color: value ? "green" : "grey",
                            }}
                            onClick={() => {
                              changeStatus(row.columnKey, col["dataField"]);
                            }}
                          >
                            {value ? (
                              <ToggleOnIcon
                                sx={{
                                  fontSize: "2rem",
                                }}
                              />
                            ) : (
                              <ToggleOffIcon
                                sx={{
                                  fontSize: "2rem",
                                }}
                              />
                            )}
                          </div>
                        )}
                      </TableCell>
                    );
                  })}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};
